import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTeacherTeaching } from "../hooks/useTeacherTeaching";
import { getSubjectId } from "../utils/teacherSubjects";
import { userShowsSubjectSelector } from "../utils/staffRoles";

const TeacherSubjectSelector = ({ compact = false }) => {
    const { currentUser } = useSelector((state) => state.user);
    const showSelector = userShowsSubjectSelector(currentUser);

    const { subjects, activeSubjectId, setActiveSubjectId, subjectName, className, hasMultipleSubjects } =
        useTeacherTeaching();

    if (!showSelector) return null;

    if (subjects.length === 0) {
        return (
            <Typography variant="caption" color="warning.main" sx={{ px: 2, py: 1, display: "block" }}>
                No subjects assigned yet. Contact your administrator.
            </Typography>
        );
    }

    if (!hasMultipleSubjects) {
        if (compact) return null;
        return (
            <Stack sx={{ px: 2, py: 1 }}>
                <Typography variant="caption" color="text.secondary">
                    Teaching ({subjects.length} subject{subjects.length === 1 ? "" : "s"})
                </Typography>
                <Typography variant="body2" fontWeight={700}>
                    {subjectName} · {className}
                </Typography>
            </Stack>
        );
    }

    return (
        <FormControl fullWidth size="small" sx={{ px: 2, py: 1, minWidth: 0 }}>
            <InputLabel id="teacher-active-subject-label">Active subject</InputLabel>
            <Select
                labelId="teacher-active-subject-label"
                label="Active subject"
                value={activeSubjectId || ""}
                onChange={(e) => setActiveSubjectId(e.target.value)}
            >
                {subjects.map((subject) => {
                    const id = getSubjectId(subject);
                    const cls = subject.sclassName?.sclassName || "Class";
                    return (
                        <MenuItem key={id} value={id}>
                            {subject.subName} — {cls}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default TeacherSubjectSelector;
